import React from 'react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { EditTitleFieldsModal } from '@teetsh/app/src/components/EditTitleFieldsModal';
import InputGroup from '@teetsh/app/src/components/Form/InputGroup';
import { updateFolderTitlePayloadAtom } from './atom';

export function UpdateFolderTitleModal() {
  const { t } = useTranslation(['sequence', 'common']);
  const [payload, setPayload] = useAtom(updateFolderTitlePayloadAtom);

  const updateField = (value: string) => {
    if (!payload) return;
    setPayload({ ...payload, title: value });
  };

  const handleSave = () => {
    if (!payload) return;
    payload.onSave(payload.title);
  };

  return (
    <EditTitleFieldsModal
      atom={updateFolderTitlePayloadAtom}
      labels={{
        title: t('sequence:actions.renameFolder'),
      }}
      onSave={handleSave}
    >
      <InputGroup
        id="folder-title-input"
        label={t('common:title')}
        value={payload?.title || ''}
        onChange={updateField}
        autoFocus
        large
      />
    </EditTitleFieldsModal>
  );
}
